module.exports = __webpack_public_path__ + "img/ax.1313bc24.svg";